// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CreateAssetMutationVariables = Types.Exact<{
  input: Types.AssetInput;
}>;


export type CreateAssetMutation = { __typename?: 'Mutation', createAsset: { __typename?: 'CreateAssetResult', asset: { __typename?: 'Asset', id: string, contentType: string, downloadUrl: string, attachmentUrl: string, url: string, fileName?: string | null | undefined, fileSizeInBytes?: number | null | undefined, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], version: string } } };

export type CreateAssetResultFragment = { __typename?: 'Asset', id: string, contentType: string, downloadUrl: string, attachmentUrl: string, url: string, fileName?: string | null | undefined, fileSizeInBytes?: number | null | undefined, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], version: string };

export const CreateAssetResultFragmentDoc = gql`
    fragment CreateAssetResult on Asset {
  id
  contentType
  downloadUrl
  attachmentUrl
  url
  fileName
  fileSizeInBytes
  createdAt
  updatedAt
  version
}
    `;
export const CreateAssetDocument = gql`
    mutation CreateAsset($input: AssetInput!) {
  createAsset(input: $input) {
    asset {
      ...CreateAssetResult
    }
  }
}
    ${CreateAssetResultFragmentDoc}`;

/**
 * __useCreateAssetMutation__
 *
 * To run a mutation, you first call `useCreateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetMutation, { data, loading, error }] = useCreateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAssetMutation, CreateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAssetMutation, CreateAssetMutationVariables>(CreateAssetDocument, options);
      }
export type CreateAssetMutationHookResult = ReturnType<typeof useCreateAssetMutation>;
export type CreateAssetMutationResult = ApolloReactCommon.MutationResult<CreateAssetMutation>;